/* Nieuw bij Banky op de home, "De route" (home ronde 4, 06-10-2026, tak wp/home4b; sections/banky-home-nieuw.liquid,
   CSS in banky-pagina-home.css). Ontwerp design/home-secties-0610/nieuw-v4.html.
   1. Beweging, alleen transform en opacity: niet bij prefers-reduced-motion, in de thema-editor, zonder
      IntersectionObserver of voor zoekmachinerobots (zoals de klantenteller in banky-sales.js); zonder dit script staat
      alles stil in beeld. Pas als de sectie tot 200px onder het scherm komt, gaat de beginstand aan (.is-beweeg: lijn
      leeg, lampjes uit, producten en tekst nog weg), bij 20% in beeld speelt de eerste keer (.is-in). Staat de sectie
      bij het laden al in beeld, dan zonder de eerste keer (.is-direct), zodat niets verdwijnt dat er al staat. Daarna de
      rustige herhaling (na 12 s, dan om de 16 s); buiten beeld staat alles stil (zonder .is-zicht).
      Per halte zet het script --t (moment dat de stroom bij de halte is, 0,2 tot 2 s) en --p (moment dat de glans bij
      de halte is, 0 tot 2,8 s) uit de plek van de halte langs de lijn, zoals het ontwerp.
   2. Plusknop: na toevoegen (Halo's variant:add uit het formulier, de lade opent zoals bij de kaarten) 1,6 s een vinkje.
   3. Video bij een halte (WP nieuw-video, Geert 18-10-2026: "checkt op maximale snelheid voor laden"): heeft de sectie een
      venster (data-av), dan laadt dit script banky-home-nieuw-video.css en daarna banky-home-nieuw-video.js pas als het
      venster tot 800px onder het scherm komt (zonder IntersectionObserver meteen). Tot dan komt er niets van de video
      binnen: geen script, geen opmaak van de speler, geen poster en geen videobestand. Ook bij minder beweging, want de
      afspeelknop en de speler werken dan wel. */
(() => {
  const secties = document.querySelectorAll('[data-banky-nieuw]');
  if (!secties.length || window.bankyHomeNieuw) return;
  window.bankyHomeNieuw = true;
  const GLANS = 2.8;
  const stil = (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) || window.Shopify?.designMode
    || !('IntersectionObserver' in window) || /bot|crawl|spider|slurp/i.test(navigator.userAgent);

  const meet = sec => {
    const lijn = sec.querySelector('[data-lijn]');
    const r = lijn && lijn.getBoundingClientRect();
    if (!r || !r.width || !r.height) return;
    const liggend = r.width > r.height;
    sec.querySelectorAll('[data-stop]').forEach(stop => {
      const punt = stop.querySelector('.banky-nieuw__punt');
      if (!punt) return;
      const d = punt.getBoundingClientRect();
      const f = Math.max(0, Math.min(1, liggend ? (d.left + d.width / 2 - r.left) / r.width : (d.top + d.height / 2 - r.top) / r.height));
      stop.style.setProperty('--t', (0.2 + f * 1.8).toFixed(2) + 's');
      stop.style.setProperty('--p', (f * GLANS).toFixed(2) + 's');
    });
  };

  const laadVideo = av => {
    if (window.bankyAvGeladen) return;
    window.bankyAvGeladen = true;
    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = av.dataset.css;
    css.onload = css.onerror = () => {
      const js = document.createElement('script');
      js.src = av.dataset.js;
      document.head.append(js);
    };
    document.head.append(css);
  };

  secties.forEach(sec => {
    const av = sec.querySelector('[data-av]');
    if (av && !('IntersectionObserver' in window)) laadVideo(av);
    else if (av) {
      const io = new IntersectionObserver(es => {
        if (es.some(e => e.isIntersecting)) { io.disconnect(); laadVideo(av); }
      }, {rootMargin: '0px 0px 800px 0px'});
      io.observe(av);
    }
    sec.addEventListener('variant:add', e => {
      const knop = e.target && e.target.querySelector ? e.target.querySelector('.banky-nieuw__plus') : null;
      if (!knop) return;
      knop.classList.add('is-toegevoegd');
      clearTimeout(knop.bankyTijd);
      knop.bankyTijd = setTimeout(() => knop.classList.remove('is-toegevoegd'), 1600);
    });
    if (stil) return;
    const k = sec.getBoundingClientRect();
    if (k.top < innerHeight && k.bottom > 0) {
      meet(sec);
      sec.classList.add('is-beweeg', 'is-direct', 'is-in', 'is-zicht');
    }
    new IntersectionObserver(es => {
      if (es.some(e => e.isIntersecting)) sec.classList.add('is-beweeg');
    }, {rootMargin: '0px 0px 200px 0px'}).observe(sec);
    new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) { sec.classList.remove('is-zicht'); return; }
      sec.classList.add('is-zicht');
      if (e.intersectionRatio >= 0.2 && !sec.classList.contains('is-in')) {
        meet(sec);
        sec.classList.add('is-beweeg', 'is-in');
      }
    }), {threshold: [0, 0.2]}).observe(sec);
  });
})();
